// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-50d54c53] .van-icon-arrow-down:before {\n  color: pink !important;\n}", ""]);
// Exports
module.exports = exports;
